export default "__VITE_ASSET__CXV7oXSb__"